import { observable, action } from 'mobx';
import { getIDs } from '../components/Matrix/functions/getID';
import { RootStore } from './RootStore';




export type View = 'stages' | 'documents' | 'problems' | 'structure'

export class SelectionStore {

    rootStore = RootStore;
    constructor(rootStore: any) {
        this.rootStore = rootStore
    }



    @observable view: View = 'stages'
    @action setView = (v: View) => {
        
        // Resetting all selected documents, problems and organizations

        if (v === 'stages'){
            this.doc = null
            this.problem = null
        }
        if (v === 'documents'){
            // this.doc = null
            this.problem = null
            this.org = null
            this.orgStage = null
        }
        if (v === 'problems'){
            this.doc = null
            // this.problem = null
            this.org = null
            this.orgStage = null
        }
        if (v === 'structure'){
            this.doc = null
            this.problem = null
            // this.org = null
            this.stage = null
            this.orgStage = null
        }


        this.view = v

    }



    @observable stage: string | null = null
    @observable org: string | null = null
    @observable doc: string | null = null
    @observable problem: string | null = null

    @observable orgStage: string | null = null
    @action setOrgStage = (id: string) => {
        const { stageID, orgID } = getIDs(id)
        this.orgStage = id
        this.stage = stageID
        this.org = orgID
    }

    @action setStage = (s: string) => {
        this.stage = s
        this.org = null
        this.orgStage = null
        // When changing stage, resetting previosly selected documents and problems
        this.problem = null
        this.doc = null
    }

    @action setOrg = (o: string) => {
        this.org = o
        this.stage = null
        this.orgStage = null
    }

    @action setDoc = (d: string | null) => {
        this.doc = d
    }

    @action setProblem = (p: string | null) => {
        this.problem = p
    }
    
}